import { render } from "./OurAdvantages.vue?vue&type=template&id=3bc9640c&scoped=true"
const script = {}

import "./OurAdvantages.vue?vue&type=style&index=0&id=3bc9640c&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc9640c"]])

export default __exports__